import React, { useState } from "react";
import CardImage1 from "../../assets/Images/Homepage/FullStackExpertise/audit.png";
import CardImage2 from "../../assets/Images/Homepage/FullStackExpertise/build.png";
import CardImage3 from "../../assets/Images/Homepage/FullStackExpertise/consult.png";
import "./style.scss";
import RevealAnimation from "../RevealAnimation";
import Button from "../Button";
import RightArrow from "../../assets/Icons/go.svg";
import RightArrowWhite from "../../assets/Icons/accordian_white.svg";
import { useContactModal } from "../Modal/contactModalContext";
import { Link, navigate } from "gatsby";

function FullStackExpertise({
  title = "Our Expertise",
  parentWarp = "our-modal-wrap",
  showButton = true,
  showItems = ["Consult", "Audit", "Build"],
  isServiceCard = false,
  isAboutPage = false,
  cardContainer = "",
}) {
  const [isHover, setIsHover] = useState(false);
  const { setOpenModal } = useContactModal();

  const CardListData = [
    {
      image: CardImage3,
      title: "Consult",
      subTitle:
        "Get expert insight to shape your digital strategy and product roadmap.",
      route: "/consult",
    },
    {
      image: CardImage1,
      title: "Audit",
      subTitle: "Spot risks, fix gaps, and optimise before you scale.",
      route: "/audit",
    },
    {
      image: CardImage2,
      title: "Build",
      subTitle:
        "Bring your vision to life with fast, scalable digital solutions.",
      route: "/build",
    },
  ];

  const toggleHover = () => {
    setIsHover(!isHover);
  };
  const filteredCardListData = CardListData.filter((item) =>
    showItems.includes(item.title)
  );

  return (
    <div className={`${parentWarp}`}>
      <div className="body-container">
        {isAboutPage ? (
          title
        ) : (
          <RevealAnimation
            component={"h2"}
            animation={"slide-left"}
            className="title-header mt-15 title-underline"
          >
            {title}
          </RevealAnimation>
        )}
      </div>
      <div className={`mt-70`}>
        {/* <BlurCardList
          componentId="1"
          loadMore
          BlurCardListData={BlurCardListData}
          loadMoreLabel="Show All"
        /> */}
        <div className="expertise-items body-container">
          {filteredCardListData.map((item, idx) => (
            <Link to={`/services${item.route}`} key={idx} style={{textDecoration: 'none'}}>
              <div
                className={`${
                  isServiceCard ? "service-item-wrapper" : "card-item-wrapper"
                } ${cardContainer}`}
              >
                <div className="card-img-wrapper">
                  <img alt={item.title} src={item.image} />
                </div>
                <div className="card-content-wrapper">
                  <h2>{item.title}</h2>
                  <p>{item.subTitle}</p>

                  <Button
                    icon={
                      <img
                        className="effect-btn-svgicon"
                        src={!isHover ? RightArrow : RightArrowWhite}
                        alt="Load More"
                      />
                    }
                    customClassName={
                      isAboutPage ? "info-button-our-about" : "info-button-our "
                    }
                    color="primary"
                    variant="text"
                    onClick={(e) => e.stopPropagation()}
                    label="Learn More"
                    tip="Learn More"
                    tooltip="no"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {showButton && (
        <div style={{ width: "100%", textAlign: "center" }}>
          {isAboutPage ? (
            <div className="our-about-us">
              <a
                href="/contact-us"
                style={{ textDecoration: "none" }}
                className="our-submit-btn"
              >
                Talk to Our Experts <span className="arrow">&rarr;</span>
              </a>
            </div>
          ) : (
            <div
              onMouseEnter={toggleHover}
              onMouseLeave={toggleHover}
              className="mt-60"
              role="presentation"
              style={{ display: "inline-block" }}
            >
              <Button
                icon={
                  <img
                    className="effect-btn-svgicon"
                    src={!isHover ? RightArrow : RightArrowWhite}
                    alt="Load More"
                  />
                }
                customClassName="info-view-resize-btn info-view-resize-btn-red"
                color="primary"
                variant="outlined"
                onClick={() => {
                  navigate("/contact-us");
                  // setOpenModal(true)
                }}
                label="Talk to Our Experts"
                tip="Talk to Our Experts"
                tooltip="no"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default FullStackExpertise;
